export enum DeviceType {
  mobile = "mobile",
  tablet = "tablet",
  bigTablet = "bigTablet",
  desktop = "desktop",
}
